import { Wallet } from '@injectivelabs/wallet-ts'

export default {
  wallet: {
    beta: 'Beta',
    wallet: 'Wallet',
    address: 'Address',
    connect: 'Connect',
    overview: 'Overview',
    popular: 'Popular',
    otherWallets: 'Other Wallets',
    connectWallet: 'Connect Wallet',
    disconnect: 'Disconnect wallet',
    disconnectWallet: 'Disconnect wallet',
    connectUsingTorus: 'One-click login with',
    successfullyConnected: 'Successfully Connected',
    connectUsingBrowser: 'Connect using browser wallet',
    connectUsingHardware: 'Connect using a hardware wallet',
    connectWalletToUseNotifications: 'Connect your wallet to use notifications',

    hardwareWallet: {
      getAddresses: 'Get addresses',
      getMoreAddresses: 'Get more addresses',
      selectAddressToConnect: 'Select address to connect',
      getAddressNote: 'We are getting your addresses, please wait ...'
    },

    trezor: {
      note: 'Note: To ensure smooth process while connecting your Trezor Hardware Wallet, please ensure you are running the on latest Chrome version, have your Trezor device connected and unlocked.'
    },

    ledger: {
      ledgerLive: 'Ledger Live',
      ledgerLegacy: 'Ledger Legacy',
      derivationPath: 'Derivation Path',
      selectDerivationPath: 'Select Derivation Path',
      note: 'Note: To ensure smooth process while connecting your Ledger Hardware Wallet, please ensure you are running the on latest Chrome version, have your Ledger device connected, unlocked and your Ethereum app open.'
    },

    option: {
      [Wallet.Leap]: 'Leap',
      [Wallet.Keplr]: 'Keplr',
      [Wallet.Torus]: 'Torus',
      [Wallet.Ninji]: 'Ninji',
      [Wallet.Ledger]: 'Ledger',
      [Wallet.Trezor]: 'Trezor',
      [Wallet.Phantom]: 'Phantom',
      [Wallet.Metamask]: 'Metamask',
      [Wallet.OkxWallet]: 'OKX Wallet',
      [Wallet.BitGet]: 'Bitget Wallet',
      [Wallet.TrustWallet]: 'Trust Wallet',
      [Wallet.Cosmostation]: 'Cosmostation',
      [Wallet.WalletConnect]: 'Wallet Connect'
    }
  }
}
